import React from 'react';
import LeaveApplication from '../../../componant/leave-application/leave-application';
import { useNavigate } from 'react-router-dom';

const ApplyLeavePage = () => {
    const navigate = useNavigate();
    const handleClose = () => {
        navigate('/user/dashboard');
    };

    return (
        <div className='main'>
            <div className='main-container'>
                <LeaveApplication onClose={handleClose} isFullPage={true} />
            </div>
        </div>
    );
};

export default ApplyLeavePage;
